import InScope from './InScope';
import OutScope from './OutScope';

const PolicyScopes = () => {
    return (
        <>
            <InScope />
            <OutScope />
        </>
    );
};

export default PolicyScopes;
